import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApproversListResult } from 'api/services/Admin';
import { RootState } from 'store';

type ApproversState = {
  approvers: ApproversListResult[];
};

const initialState: ApproversState = {
  approvers: [],
};

export const approverSlice = createSlice({
  name: 'approvers',
  initialState,
  reducers: {
    setApprovers(
      state: ApproversState,
      action: PayloadAction<ApproversListResult[]>
    ) {
      state.approvers = action.payload;
    },
  },
});

export const { setApprovers } = approverSlice.actions;
export const approversSelector = (state: RootState): ApproversState =>
  state.approversList;
